
    const data = {"name":"src/core/icons/chevron-right","data":{"width":"24","height":"24","viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M8.59 16.58 13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.42Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            